module.exports = __webpack_public_path__ + "buddha_logo_final.e0a4a049f74d358c57de.png";